<h1 mat-dialog-title>Nieuwe cliënt</h1>

<mat-dialog-content>
  <form class="flex flex-col gap-4" [formGroup]="form">
    <div class="space-y-2">
      <label for="name" class="block font-medium text-sm select-none">Naam</label>

      <mat-form-field class="w-full">
        <input
          matInput
          formControlName="name"
          autocomplete="off"
          enterkeyhint="next"
          id="name"
          type="text"
        />

        @if (controls.name.hasError('required')) {
          <mat-error>Dit veld is verplicht</mat-error>
        } @else if (controls.name.hasError('maxlength')) {
          <mat-error
            >Max.
            {{ controls.name.getError('maxlength').requiredLength }}
            karakters</mat-error
          >
        }
      </mat-form-field>
    </div>

    <div class="space-y-2">
      <label for="nickname" class="block font-medium text-sm select-none"
        >Roepnaam</label
      >

      <mat-form-field class="w-full">
        <input
          matInput
          formControlName="nickname"
          autocomplete="off"
          enterkeyhint="done"
          id="nickname"
          type="text"
        />

        @if (controls.nickname.hasError('required')) {
          <mat-error>Dit veld is verplicht</mat-error>
        } @else if (controls.nickname.hasError('maxlength')) {
          <mat-error
            >Max.
            {{ controls.nickname.getError('maxlength').requiredLength }}
            karakters</mat-error
          >
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted() || form.invalid">
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
